import {
  FORGET_PASSWORD,
  GET_DETAILS_TO_RESET_PASSWORD,
  INIT_URL,
  SET_ORG_DATA,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET
} from "../../constants/ActionTypes";
import { hasSession } from "../../util/session";

const INIT_STATE = {
  // Truthy when this browser has a session; the access token itself is held by util/session
  token: hasSession() ? 'session' : null,
  initURL: '',
  authUser: (localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined') ? JSON.parse(localStorage.getItem('user')) : null,
  resetTokenValid: false,
  forgetPasswordStatus: null,
  orgData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case FORGET_PASSWORD: {
      return {
        ...state,
        forgetPasswordStatus: action.payload.success,
      };
    }

    case GET_DETAILS_TO_RESET_PASSWORD: {
      return {
        ...state,
        resetTokenValid: action.payload.success,
      };
    }

    case SET_ORG_DATA: {
      return {
        ...state,
        orgData: action.payload,
      };
    }

    default:
      return state;
  }
}
